/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';

import LocalizationConsumer from '../../../../l10n/localization-context';

export const LinkOptions = ({ isHidden, openInNewWindow, onChange }) => {

  if (isHidden) return null;

  return (
    <div className="-wa-edit-controls__property-container -wa-edit-controls__link-options">
      <div className="-wa-edit-controls__property-label -wa-edit-controls__property-label-link-in">
        <LocalizationConsumer id="insert-link-dialog.link-options.open-in.title" />
      </div>
      <div className="-wa-edit-controls__property-control">
        <div className="-wa-edit-controls__radio-button-1">
          <input
            id="idRadioOpenInNewWindow"
            className="-wa-edit-controls__property-input -wa-edit-controls__property-link-input"
            name="openInNewWindow"
            type="radio"
            value="true"
            checked={openInNewWindow === true}
            onChange={e => onChange(e)}
          />
          <label
            className="-wa-edit-controls__property-label -wa-edit-controls__property-link-label"
            htmlFor="idRadioOpenInNewWindow"
          >
            <LocalizationConsumer id="insert-link-dialog.link-options.open-in.new-window" />
          </label>
        </div>
        <div className="radioButton02">
          <input
            id="idRadioOpenInSameWindow"
            className="-wa-edit-controls__property-input -wa-edit-controls__property-link-input"
            name="openInNewWindow"
            type="radio"
            value="false"
            checked={openInNewWindow === false}
            onChange={e => onChange(e)}
          />
          <label
            className="-wa-edit-controls__property-label -wa-edit-controls__property-link-label"
            htmlFor="idRadioOpenInSameWindow"
          >
            <LocalizationConsumer id="insert-link-dialog.link-options.open-in.same-window" />
          </label>
        </div>
      </div>
    </div>
  );
};

LinkOptions.propTypes = {
  isHidden: PropTypes.bool.isRequired,
  openInNewWindow: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default LinkOptions;
